/**
 * 管理后台：地图设置
 */
import { useState } from 'react';
import { message } from '../utils/antdMessage';
import { confirmDangerousAction } from '../pages/admin/dangerConfirm';
import { normalizeContourLodSettings } from '../utils/contourLodSettings';

export default function useAdminMapSettings({ apiRequest, fetchMembers, memberPagination }) {
  const [mapSettings, setMapSettings] = useState({
    map_display_days: 7,
    map_auto_cleanup: false,
    overlay_name_click_fly: 'bounds',
    panorama_show_map_markers: true,
    panorama_marker_size: 22,
    panorama_marker_icon_id: null,
    contour_lod: {
      enabled: true,
      steps: [
        { aboveMeters: 1500, interval: 50 },
        { aboveMeters: 3000, interval: 100 },
        { aboveMeters: 8000, interval: 0 }
      ]
    }
  });
  const [mapSettingsMsg, setMapSettingsMsg] = useState('');

  const fetchMapSettings = async () => {
    try {
      const data = await apiRequest('/api/admin/map-settings');
      if (data.success) {
        setMapSettings({
          ...data.settings,
          contour_lod: normalizeContourLodSettings(data.settings?.contour_lod)
        });
      }
    } catch (e) {
      console.error('获取地图设置失败:', e);
    }
  };

  const handleSaveMapSettings = async () => {
    try {
      const data = await apiRequest('/api/admin/map-settings', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(mapSettings)
      });
      
      if (data.success) {
        message.success(data.message);
      } else {
        setMapSettingsMsg(data.error || '保存失败');
      }
    } catch (e) {
      setMapSettingsMsg('网络错误');
    }
  };

  const handleCleanupLocationData = async (days) => {
    let confirm_text;
    try {
      confirm_text = await confirmDangerousAction({
        title: '清理位置数据',
        content: `确定要清理${days}天前的所有位置数据吗？此操作不可恢复！`
      });
    } catch {
      return;
    }

    try {
      const data = await apiRequest('/api/admin/cleanup-location-data', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ days, confirm_text })
      });

      if (data.success) {
        message.success(data.message);
        fetchMembers(memberPagination.current);
      } else {
        setMapSettingsMsg(data.error || '清理失败');
      }
    } catch (e) {
      setMapSettingsMsg('网络错误');
    }
  };

  return {
    mapSettings, setMapSettings, mapSettingsMsg,
    fetchMapSettings, handleSaveMapSettings, handleCleanupLocationData
  };
}
